import { Box, Grid } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import NoData from "../../../components/UI/NoData";
import Table from "../../../components/UI/Table/Table";
import { ITopMedSchedule } from "../../../models/topmed";
import { Calendar } from "../../../pages/Schedule/Schedule/Calendar";
import { ITopMedSchedulesTableProps } from "./models";
import { Actions } from "../Actions/Actions";

const TRASNLATION_PATH = "page.topmedSchedule.mySchedules.";

const MySchedulesTable: React.FC<ITopMedSchedulesTableProps> = ({
  data,
  onRefresh,
}) => {
  const { t } = useTranslation();

  const columns: GridColDef<ITopMedSchedule>[] = [
    {
      field: "calendarDate",
      headerName: t(TRASNLATION_PATH + "date")!,
      flex: 1,
      maxWidth: 150,
      renderCell: ({ row: { date } }) => <Calendar date={date} />,
    },

    {
      field: "patientName",
      headerName: t(TRASNLATION_PATH + "patientName")!,
      minWidth: 200,
      flex: 1,
    },
    {
      field: "physicianName",
      headerName: t(TRASNLATION_PATH + "physicianName")!,
      minWidth: 200,
      flex: 1,
    },
    {
      field: "hash",
      headerName: t(TRASNLATION_PATH + "actions")!,
      flex: 1,
      maxWidth: 200,
      renderCell: ({ row }) => <Actions props={row} onRefresh={onRefresh} />,
    },
  ];

  return (
    <Box pb={2} height={"100%"} width={"99%"}>
      <Table
        columns={columns}
        rows={data.map((c) => ({ ...c, id: c.hash }))}
        rowHeight={150}
      />

      {data.length === 0 && (
        <Grid container mt={5}>
          <Grid item xs={12} sm={12}>
            <NoData />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default memo(MySchedulesTable);
